// Input validation functions
export const validateEmail = (email) => {
  if (!email) return false;
  // RFC 5322 compliant email regex
  const emailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
  return emailRegex.test(email);
};

export const validateName = (name) => {
  if (!name) return false;
  // At least 2 characters, letters, spaces and hyphens only
  const nameRegex = /^[a-zA-Z\s-]{2,50}$/;
  return nameRegex.test(name.trim());
};

export const validateAmount = (amount) => {
  if (!amount) return false;
  // Amount should be a positive number not exceeding 50,000 PLN
  const numAmount = Number(amount);
  return !isNaN(numAmount) && numAmount > 0 && numAmount <= 50000;
};

export const sanitizeInput = (input) => {
  if (!input) return '';
  // Remove potentially dangerous characters
  return input.replace(/[<>&'"]/g, '');
};

export const validateTourId = (tourId) => {
  if (!tourId) return false;
  // TourId should be alphanumeric with optional hyphens
  const tourIdRegex = /^[a-zA-Z0-9-]{1,50}$/;
  return tourIdRegex.test(tourId);
};

// Security utility functions
export const createNonce = () => {
  const array = new Uint32Array(1);
  window.crypto.getRandomValues(array);
  return array[0].toString(36);
};

export const validateOrigin = (origin) => {
  try {
    const parsedOrigin = new URL(origin);
    const localHosts = new Set(["localhost", "127.0.0.1", "[::1]", "::1"]);

    if (localHosts.has(parsedOrigin.hostname)) {
      return true;
    }

    const allowedOrigins = new Set([
      "https://guidehub-2cf45.web.app",
      "https://guidehub-2cf45.firebaseapp.com",
      "https://guidehubpartner.web.app",
      "https://guidehubpartner.firebaseapp.com",
      "https://app.guidehub.eu",
    ]);

    return allowedOrigins.has(parsedOrigin.origin);
  } catch (_error) {
    return false;
  }
};

// Error logging utility
export const secureErrorLog = (error, context = {}) => {
  // Remove sensitive data before logging
  const sanitizedError = {
    message: error.message || 'Unknown error',
    code: error.code || 'NO_CODE',
    step: error.step || 'unknown',
    timestamp: new Date().toISOString(),
    ...context
  };

  // Remove any potentially sensitive data
  delete sanitizedError.detail;
  delete sanitizedError.stack;
  delete sanitizedError.authToken;
  delete sanitizedError.sessionId;

  console.error('[Secure Error Log]', sanitizedError);
  return sanitizedError;
};
